'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.PerfectScrollbar', []).directive('rmPerfectScrollbar', require('./directives/PerfectScrollbarDirective'));